import { FC, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "../firebase";
import { logEvent, setUserId, setUserProperties } from "firebase/analytics";
import { useSelector } from "react-redux";
import { IUserOptions } from "../types/interfaces";

export const AnalyticsTracker: FC = () => {
  const { data } = useSelector((state: IUserOptions) => state.user.user);
  const location = useLocation();
  const enterTimeRef = useRef<number>(Date.now());
  
  useEffect(() => {
    if (data.login) {
      console.log("Setting userId and userProperties:", data.login);
      setUserId(analytics, data.login);
      setUserProperties(analytics, { user_login: data.login });
      logEvent(analytics, "test_event", {
        user_login: data.login,
        debug_mode: 1,
      });
    }
  }, [data.login]);
  
  useEffect(() => {
    const now = Date.now();
    const durationMs = now - enterTimeRef.current;
    
    if (enterTimeRef.current) {
      logEvent(analytics, "time_on_page", {
        page: location.pathname,
        duration_seconds: Math.round(durationMs / 1000),
      });
    }
    enterTimeRef.current = now;
    
    logEvent(analytics, "screen_view", {
      firebase_screen: location.pathname,
      firebase_screen_class: location.pathname,
    });
  }, [location]);
  
  return null;
};
